import { c as _c } from "react/compiler-runtime";
import { ContactDetails } from '@/components/Atoms/ContactDetails/ContactDetails';
import { FlexItem } from '@/components/Atoms/FlexItem/FlexItem';
import { GridWrapper } from '@/components/Atoms/GridWrapper/GridWrapper';
import { Hidden } from '@/components/Atoms/Hidden/Hidden';
import { Icon, IconSize } from '@/components/Atoms/Icon/Icon';
import { InlineList } from '@/components/Atoms/InlineList/InlineList';
import { Prose } from '@/components/Atoms/Prose/Prose';
import { H6 } from '@/components/Core/Heading';
import LinkedIn from '@/components/Icons/LinkedIn';
import { CenteredPageContent } from '@/components/Layouts/CenteredPageContent';
import { Stack } from '@/components/Molecules/Stack/Stack';
import useTranslation from '@/hooks/useTranslation';
import type { MouseEventHandler } from 'react';
import type { FCl } from 'react-fc';
import styles from './Footer.module.css';
export const CHINA_ICP_CODE = '沪ICP备17049401号-4';
const currentYear = new Date().getFullYear();
export const Footer: FCl<IFooterProps> = t0 => {
  const $ = _c(39);
  const {
    className,
    onMouseEnter
  } = t0;
  const {
    t
  } = useTranslation("common");
  const t1 = `${styles.footerBar} ${className || ""}`;
  let t2;
  if ($[0] !== t) {
    t2 = t("ContactDetails.inquiries");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <H6 as="h2">{t2}</H6>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ContactDetails />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <FlexItem $s={40} className={styles.footerTopLeft}><Stack $half={true}>{t3}{t4}</Stack></FlexItem>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t) {
    t6 = t("Footer.corporate_site");
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6) {
    t7 = <li><a href="https://about.bnef.com/">{t6}</a></li>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t) {
    t8 = t("Footer.privacy_policy");
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <li><a href="/privacy-policy">{t8}</a></li>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t) {
    t10 = t("Footer.tos");
    $[15] = t;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10) {
    t11 = <li><a href="/terms-service">{t10}</a></li>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <li><a href="https://www.bloomberg.com/" target="_blank" rel="nofollow me noopener noreferrer">bloomberg.com</a></li>;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t11 || $[21] !== t7 || $[22] !== t9) {
    t13 = <FlexItem $s={60} className={styles.footerTopRight}><ul className={`${styles.linksList} cds-t-body`}>{t7}{t9}{t11}{t12}</ul></FlexItem>;
    $[20] = t11;
    $[21] = t7;
    $[22] = t9;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t13 || $[25] !== t5) {
    t14 = <GridWrapper>{t5}{t13}</GridWrapper>;
    $[24] = t13;
    $[25] = t5;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <hr />;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  let t17;
  let t18;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <p><small>The BloombergNEF ("BNEF"), service/information is derived from selected public sources. Bloomberg Finance L.P. and its affiliates, in providing the service/information, believe that the information it uses comes from reliable sources, but do not guarantee the accuracy or completeness of this information, which is subject to change without notice, and nothing in this document shall be construed as such a guarantee. The statements in this service/document reflect the current judgement of the authors of the relevant articles or features, and do not necessarily reflect the opinion of Bloomberg Finance L.P., Bloomberg L.P. or any of their affiliates (“Bloomberg”). Bloomberg disclaims any liability arising from use of this document, its contents and/or this service. Nothing herein shall constitute or be construed as an offering of financial instruments or as investment advice or recommendations by Bloomberg of an investment or other strategy (e.g., whether or not to “buy”, “sell”, or “hold” an investment). The information available through this service is not based on consideration of a subscriber's individual circumstances and should not be considered as information sufficient upon which to base an investment decision. You should determine on your own whether you agree with the content. This service should not be construed as tax or accounting advice or as a service designed to facilitate any subscriber's compliance with its tax, accounting or other legal obligations. Employees involved in this service may hold positions in the companies mentioned in the services/information.</small></p>;
    t17 = <p><small>Bloomberg historical ESG scores are accessible here, which include data and methodology that is no longer reviewed, maintained or updated. By accessing these scores, you acknowledge that these scores, and any third party ESG scores or opinions, which were produced before 2 July 2026, were not produced in accordance with the requirements of Regulation (EU) 2024/3005 and these scores constitute historical data.</small></p>;
    t18 = <p><small>Indian ESG Data is not available for use, is not intended for use and must not be used in India. Prospective users should consider the appropriateness and suitability of the usage of Indian ESG Data in accordance with their particular circumstances and regulatory obligations. “Indian ESG Data” means a certain rating product or other type of evaluation and related data or information made available by Bloomberg or any third party regarding (i) an ESG profile or characteristics, (ii) exposure to ESG risk, governance risk, social risk, climatic or environmental risks, or (iii) impact on society, climate and the environment, in each case, of an issuer or a security which is listed or proposed to be listed on a stock exchange recognized by the Securities and Exchange Board of India.</small></p>;
    $[28] = t16;
    $[29] = t17;
    $[30] = t18;
  } else {
    t16 = $[28];
    t17 = $[29];
    t18 = $[30];
  }
  let t19;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Prose>{t16}{t17}{t18}<p><small>The data included in these materials are for illustrative purposes only. The BLOOMBERG TERMINAL service and Bloomberg data products (the “Services”) are owned and distributed by Bloomberg Finance L.P. (“BFLP”) except (i) in Argentina, Australia and certain jurisdictions in the Pacific islands, Bermuda, China, India, Japan, Korea and New Zealand, where Bloomberg L.P. and its subsidiaries (“BLP”) distribute these products, and (ii) in Nigeria, Singapore and the jurisdictions serviced by Bloomberg's Singapore office, where a subsidiary of BFLP distributes these products. BLP provides BFLP and its subsidiaries with global marketing and operational support and service. Certain features, functions, products and services are available only to sophisticated investors and only where permitted. BFLP, BLP and their affiliates do not guarantee the accuracy of prices or other information in the Services. Nothing in the Services shall constitute or be construed as an offering of financial instruments by BFLP, BLP or their affiliates, or as investment advice or recommendations by BFLP, BLP or their affiliates of an investment strategy or whether or not to “buy”, “sell” or “hold” an investment. Information available via the Services should not be considered as research analysis or research recommendation or an opinion concerning any financial products or securities or entity or as information sufficient upon which to base an investment decision. Bloomberg makes no claims or representations, or provides any assurances, about the sustainability characteristics, profile or data points of any underlying issuers, products or services, and users should make their own determination on such issues. The following are trademarks and service marks of BFLP, a Delaware limited partnership, or its subsidiaries: BLOOMBERG, BLOOMBERG ANYWHERE, BLOOMBERG MARKETS, BLOOMBERG NEWS, BLOOMBERG PROFESSIONAL, BLOOMBERG TERMINAL and BLOOMBERG.COM. Absence of any trademark or service mark from this list does not waive Bloomberg's intellectual property rights in that name, mark or logo. All rights reserved. © {currentYear} Bloomberg.<br /><a href="http://beian.miit.gov.cn/" rel="noopener noreferrer">{CHINA_ICP_CODE}</a></small></p></Prose>;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <InlineList className={styles.socialIcons}><li><a href="https://www.linkedin.com/company/bloombergnef"><Icon use={<LinkedIn />} size={IconSize.SMALL} /><Hidden>LinkedIn</Hidden></a></li></InlineList>;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== t14) {
    t21 = <CenteredPageContent>{t14}{t15}{t19}{t20}</CenteredPageContent>;
    $[33] = t14;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== onMouseEnter || $[36] !== t1 || $[37] !== t21) {
    t22 = <footer className={t1} onMouseEnter={onMouseEnter}>{t21}</footer>;
    $[35] = onMouseEnter;
    $[36] = t1;
    $[37] = t21;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  return t22;
};
interface IFooterProps {
  onMouseEnter?: MouseEventHandler<HTMLElement>;
}